import { PropsWithChildren } from "react";

import { FilterBar, Item, useTheme } from "@bps/fluent-ui";
import { FieldDeviceFilterArgs } from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface FieldDevicesFilterValues {
  searchTerm: string;
  isActive: boolean;
}

interface FieldDevicesFilterProps extends PropsWithChildren<any> {
  setFilterArgs: React.Dispatch<
    React.SetStateAction<FieldDeviceFilterArgs | undefined>
  >;
}

export const FieldDevicesFilter = ({
  children,
  setFilterArgs
}: FieldDevicesFilterProps) => {
  const theme = useTheme();
  // Filter Options
  const filterOptions: Item<FieldDevicesFilterValues>[] = [
    {
      type: "searchBox",
      name: "searchTerm",
      stickItem: true,
      props: {
        placeholder: "Filter by keyword",
        removeSpecialCharacters: false,
        styles: { root: { maxWidth: 1000 } }
      }
    }
  ];

  return (
    <FilterBar<FieldDevicesFilterValues>
      items={filterOptions}
      maxItemWidth={200}
      styles={{
        presets: {
          marginLeft: "auto"
        }
      }}
      initialValues={{
        searchTerm: "",
        isActive: true
      }}
      onChange={filter => {
        if (
          filter.state.values.searchTerm.length >= 4 ||
          filter.state.values.searchTerm.length === 0
        ) {
          const isActive = filter.state.values.isActive ? true : undefined;

          setFilterArgs({
            ...filter.state.values,
            isActive
          });
        }
      }}
      presets={[
        {
          name: "isActive",
          iconName: "BlockContact",
          iconColor: theme.semanticColors.errorIcon,
          text: "All devices",
          textPressed: "Active only"
        }
      ]}
    >
      {children}
    </FilterBar>
  );
};
